

export class OTPResendTimer {
  timerId = 0;
  default = 2 * 60; // 2 mins == 120 sec;
  current = this.default;
  formatedTime = '';

  reset(): void {
    this.current = this.default;
    this.formatedTime = '';
  }

  startTimer(cb = () => {}): void {
    this.stopTimer();
    this.timerId = window.setInterval(() => {
      this.current -= 1;
      const m = `${Number.parseInt(`${this.current / 60}`)}`;
      const s = `${(this.current > 60 ? this.current - 60 : this.current)}`.padStart(2, '0');
      this.formatedTime = `${m.padStart(2, '0')} : ${s.padStart(2, '0')}`;
      if (this.current === 0) {
        this.stopTimer();
        cb();
      }
    }, 1000);
  }

  stopTimer(): void {
    window.clearInterval(this.timerId);
    this.reset();
  }
}
